import { Component, OnInit, Inject } from '@angular/core';
import { DataService } from '../../utils/data.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { generalService } from '../../services/general.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-nota-cargo-descargar',
  templateUrl: './nota-cargo-descargar.component.html',
  styleUrls: ['./nota-cargo-descargar.component.scss'],
  providers: [generalService]
})
export class NotaCargoDescargarComponent implements OnInit {

  mensaje: string = '';
  confirm: boolean;
  constructor(
    public dataService: DataService,
    public dialogRef: MatDialogRef<NotaCargoDescargarComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
   
  }

  ngOnInit() {
  }

  cerrarModal() {
    this.dialogRef.close(false);
  }

  aceptar() {
    this.dialogRef.close(true);
  }

}



// WEBPACK FOOTER //
// ./src/app/nota-cargo/consultar-eliminar/nota-cargo-descargar.component.ts